import React, { Component } from 'react'
import Input from './../input'
import Radio from './../radio'
import _ from 'underscore'
import BVTextArea from './../textarea'
import { PROTOCOL } from './../../lib/helper'

class PagelyFormInputFields extends Component{
	constructor(props){
		super(props)
		this.state = {}
		this.getClassName = this.getClassName.bind(this)
		this.fetchValue = this.fetchValue.bind(this)
	}

	fetchValue(key){
		const { fields } = this.props
		let value = fields[key] || ""
		return value
	}

	getClassName(key){
		const { errors, fields } = this.props
		let classname
		if (key == "address"){
			classname = "col-md-9 col-xs-9"
		} else if (key == "port"){
			classname = "col-md-3 col-xs-3"
		} else {
			classname = "col-md-12 col-xs-12"
		}
		if (_.contains(errors, key)){
			classname += " error-field"
		}
		return classname
	}
	render(){
		return (
			<div>
				<p className="bv-form-title" style={{textAlign: "left"}}>Enter FTP Details of the new site that you want to migrate to</p>
				<div className="row">
					<div className={this.getClassName('newurl')}>
						<i className="mdi mdi-web"></i>
						<Input
							type="text"
							name="newurl"
							title="Staging URL"
							placeholder="Eg. s29794.p1108.sites.pressdns.com"
							classname=""
							value={this.fetchValue('newurl')}
						/>
					</div>
				</div>
				<div className="row">
					<div className={this.getClassName('newurl')}>
						<i className="mdi mdi-web"></i>
						<Input
							type="text"
							name="primary_url"
							title="Primary URL"
							placeholder="Eg. google.com"
							classname=""
							value={this.fetchValue('primary_url')}
						/>
					</div>
				</div>
				<div className="row">
					<div className={this.getClassName('address')}>
						<i className="mdi mdi-server"></i>
						<Input
							type="text"
							name="address"
							title="Destination Server IP/FTP Address"
							placeholder="Eg. 127.0.0.1"
							classname=""
							value={this.fetchValue('address')}
						/>
					</div>
					<div className={this.getClassName('port')}>
						<Input
							type="number"
							name="port"
							title="Port(optional)"
							placeholder=""
							classname=""
							value={this.fetchValue('port')}
						/>
					</div>
				</div>
				<div className="row">
					<div className={this.getClassName('username')}>
						<i className="mdi mdi-account"></i>
						<Input
							type="text"
							name="username"
							title="Username"
							placeholder="Enter FTP username here"
							classname=""
							value={this.fetchValue('username')}
						/>
					</div>
				</div>
				<div className="row">
					<div className="col-xs-12 col-md-12">
						<i className="mdi mdi-key"></i>
						<BVTextArea name="key_data" className="bv-ftp-password" placeholder="Paste SSH Private key here" title="SSH Key" />
					</div>
				</div> 
				<div className="row hide-field">
					<Input
						type="hidden"
						name="migrate"
						value="pagely"
						title=""
						placeholder=""
						classname=""
					/>
					<Input
						type="hidden"
						title=""
						name="type"
						placeholder=""
						classname=""
						value="sftp"
					/>
					<Input
						type="hidden"
						title=""
						name="protocol"
						placeholder=""
						classname=""
						value={PROTOCOL.SFTP}
					/>
				</div>
			</div>
		)
	}
}

export default PagelyFormInputFields
